
import { LabelLayout } from "@/utils/label-layout/label-layout";
import { compareFormat, getDefaultPageFormatsSelectItems, IFormat } from "@/utils/layout-editor";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import AppMarginEdit from "../layout-editor/MarginEdit.vue";

export default Vue.extend({
	data(){
		return {
			useCustomFormat: false
		};
	},
	props: {
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		}
	},
	computed: {
		pageFormatItems(): ISelectItem<IFormat>[] {
			return getDefaultPageFormatsSelectItems();
		},
		selectedFormat():IFormat {
			let result = this.pageFormatItems.find(v => this.compareFormat(v.value));
			if (!result) {
				return {
					width: this.layout.PageSettings.PageWidth,
					height: this.layout.PageSettings.PageHeight
				};
			}
			return result.value;
		},
		minPageWidth():number {
			return this.layout.PageSettings.getMinPageWidth();
		},
		minPageHeight():number {
			return this.layout.PageSettings.getMinPageHeight();
		}
	},
	watch: {
		"layout.PageSettings.minPageWidth": {
			immediate: true,
			handler(){
				this.checkPageWidth();
			}
		},
		"layout.PageSettings.minPageHeight": {
			immediate: true,
			handler(){
				this.checkPageHeight();
			}
		},
		"layout.PageSettings.PageWidth"(){
			this.checkPageWidth();
		},
		"layout.PageSettings.PageHeight"(){
			this.checkPageHeight();
		}
	},
	methods: {
		checkPageWidth(){
			if (this.layout.PageSettings.PageWidth < this.minPageWidth){
				this.useCustomFormat = true;
				this.layout.PageSettings.PageWidth = this.minPageWidth;
			}
		},
		checkPageHeight(){
			if (this.layout.PageSettings.PageHeight < this.minPageHeight){
				this.useCustomFormat = true;
				this.layout.PageSettings.PageHeight = this.minPageHeight;
			}
		},
		setFormat(format: IFormat) {
			if (!format)return;
			this.layout.PageSettings.PageWidth = format.width;
			this.layout.PageSettings.PageHeight = format.height;
		},
		compareFormat(format:IFormat): boolean {
			return compareFormat(format, {height: this.layout.PageSettings.PageHeight, width: this.layout.PageSettings.PageWidth});
		},
		doesFormatExist(format:IFormat):boolean {
			for (let item of this.pageFormatItems) {
				if (item.value.width != format.width){
					continue;
				}
				if (item.value.height != format.height) {
					continue;
				}
				return true;
			}
			return false;
		},
		useDefaultFormat(){
			this.useCustomFormat = false;
			if (this.doesFormatExist({height: this.layout.PageSettings.PageHeight, width: this.layout.PageSettings.PageWidth})){
				return;
			}
			this.layout.PageSettings.PageWidth = 210;
			this.layout.PageSettings.PageHeight = 297;
		}
	},
	mounted(){
		if (!this.doesFormatExist({height: this.layout.PageSettings.PageHeight, width: this.layout.PageSettings.PageWidth})) {
			this.useCustomFormat = true;
		}
	},
	components: {
		AppMarginEdit
	},
	i18nEx: {
		componentPrefix: "components.document-settings"
	}
});
